import { ComponentType } from 'react';

export interface ILinkTheme {
	ArrowLinkIcon?: ComponentType;
}

export const theme: ILinkTheme = {
	ArrowLinkIcon: undefined,
};
